import { render, staticRenderFns } from "./JourneyDropdown.vue?vue&type=template&id=636730a6&"
import script from "./JourneyDropdown.vue?vue&type=script&lang=js&"
export * from "./JourneyDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('636730a6')) {
      api.createRecord('636730a6', component.options)
    } else {
      api.reload('636730a6', component.options)
    }
    module.hot.accept("./JourneyDropdown.vue?vue&type=template&id=636730a6&", function () {
      api.rerender('636730a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/JourneyDropdown.vue"
export default component.exports